<template>
  <section class="section">
    <div class="container">
      <h1 class="title">
        {{ resurs.naslov }}
      </h1>
      <b-image
        v-for="slika in slike"
        :key="slika.id"
        :src="slikaUrl(slika.id)"
        alt="Слика"
        :rounded="false"
        class="imageCss"
      ></b-image>
      <br />
      <p class="box line-breaks">
        {{ resurs.tekst }}
      </p>
      <p>
        &nbsp;
        <a
          v-for="dokument in dokumenti"
          :key="dokument.id"
          target="_blank"
          :href="documentUrl(dokument.id)"
          class="subtitle"
          ><i class="fas fa-paperclip"></i>&nbsp;</a
        >
      </p>
      <p>
        &nbsp;
        <a
          v-for="link in linkovi"
          :key="link.id"
          target="_blank"
          :href="linkUrl(link.url)"
          >{{ link.tekst }}&nbsp;</a
        >
      </p>
      <b-button
        class="is-pulled-right"
        tag="router-link"
        :to="returnTo"
        type="is-info"
        >Назад</b-button
      >
    </div>
  </section>
</template>

<script>
import { mapState } from 'vuex'
import { baseUrl } from '@/conf'
export default {
  // props: {
  //   // resurs: {
  //   //   type: Object,
  //   //   requred: true
  //   // }
  //   id: {
  //     type: String,
  //     requred: true
  //   },
  //   tip: {
  //     type: String,
  //     requred: true
  //   }
  // },
  props: ['id', 'tip'],
  methods: {
    slikaUrl(id) {
      return baseUrl + '/slika/' + id
    },
    documentUrl(id) {
      return baseUrl + '/dokument/' + id
    },
    linkUrl(url) {
      // debugger
      if (url.startsWith('http:')) {
        return url
      } else {
        return 'http://' + url
      }
    }
  },
  computed: {
    returnTo() {
      if (this.tip === 'vest') {
        return '/vesti'
      } else if (this.tip === 'javna-nabavka') {
        return '/javne-nabavke'
      } else if (this.tip === 'cenovnik') {
        return '/cenovnici'
      } else if (this.tip === 'program') {
        return '/programi'
      } else if (this.tip === 'izvestaj') {
        return '/izvestaji'
      } else if (this.tip === 'organizacija') {
        return '/organizacija'
      } else {
        return '/'
      }
    },
    // slikaUrl() {
    //   return this.resurs.naziv_slike
    //     ? baseUrl + '/slika/' + this.resurs.id
    //     : null
    // },
    // documentUrl() {
    //   return this.resurs.naziv_dokumenta
    //     ? baseUrl + '/dokument/' + this.resurs.id
    //     : null
    // },
    slike() {
      return this.resurs.elementi.filter(e => {
        return e.tip === 'slika'
      })
    },
    dokumenti() {
      return this.resurs.elementi.filter(e => {
        return e.tip === 'dokument'
      })
    },
    linkovi() {
      // debugger
      return this.resurs.elementi.filter(e => {
        return e.tip === 'link'
      })
    },
    ...mapState({
      resurs: state => state.resursi.resurs
    })
  }
}
</script>

<style>
.imageCss {
  max-width: 600px;
}

.line-breaks {
  white-space: pre-line;
}
</style>
